import { jsx as i } from "react/jsx-runtime";
import { twMerge as n } from "tailwind-merge";
const c = ({
  children: e,
  isLast: r,
  className: o,
  isLink: x,
  onClick: t
}) => {
  const m = (a) => {
    t && (a.preventDefault(), t());
  };
  return /* @__PURE__ */ i(
    "h2",
    {
      className: n(
        "text-text-tertiary text-[18px] font-semibold leading-8 transition-colors md:truncate md:text-[20px]  lg:text-[22px]",
        o,
        (x || t) && "hover:text-text-primary cursor-pointer",
        r && "text-text-primary"
      ),
      onClick: m,
      children: e
    }
  );
};
export {
  c as BreadcrumbItem
};
